import React, {
  useContext,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { store } from "../App";
import { Pagination } from "../components";
import SectorPerformanceChart from "../components/SectorPerformanceChart";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../api/api";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import {
  PortfolioColumnDefs,
  SectorColumnDefs,
  HistoricalColumnDefs,
} from "../columns/PerformanceColumns";

import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";

interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}
export interface IOlympicData {
  symbol: string;
  transactionDate: any;
  transactionCode: any;
  amount: number;
  quantity: number;
  price: number;
  notes: any;
}

export interface IOlympicDataSector {
  sectorName: string;
  perfDate: any;
  mtdGross: any;
  qtdGross: any;
  threeMonthsGross: any;
  oneYearGross: any;
  threeYearGross: any;
  fiveYearGross: any;
  sevenYearGross: any;
  tenYearGross: any;
  sinceInceptionGross: any;
}

export interface IOlympicDataPortfolio {
  perfDate: any;
  mtdGross: any;
  qtdGross: any;
  threeMonthsGross: any;
  oneYearGross: any;
  threeYearGross: any;
  fiveYearGross: any;
  sevenYearGross: any;
  tenYearGross: any;
  sinceInceptionGross: any;
}

export const Performance = () => {
  const dataGridRefPortfolioData =
    useRef<AgGridReact<IOlympicDataPortfolio>>(null);
  const dataGridRefSectorData = useRef<AgGridReact<IOlympicDataSector>>(null);
  const dataGridRefHistoricalData = useRef<AgGridReact<IOlympicData>>(null);
  const [token, setToken, userId, setUserId] = useContext(store);

  const [PortfolioDetails, setPortfolioDetails] = useState<any>(null);
  const [portfolioCount, setPortfolioCount] = useState<any>(null);
  const [detailscurrentPage, setDetailsCurrentPage] = useState(1);

  const [sectorDetails, setSectorDetails] = useState<any>(null);
  const [sectorCount, setSectorCount] = useState<any>(null);
  const [SectorCurrentPage, setSectorCurrentPage] = useState(1);

  const [historicalDetails, setHistoricalDetails] = useState<any>(null);
  const [historicalCount, setHistoricalCount] = useState<any>(null);
  const [historicalCurrentPage, setHistoricalCurrentPage] = useState(1);

  const [portifolioPer, setPortifolioPer] = useState<any>([]);
  const [setDate, setSetDate] = useState(30);
  const [currentPage, setCurrentPage] = useState(30);
  //var toDate =
  const BeginDate = new Date(Date.now() - setDate * 24 * 60 * 60 * 1000);
  const EndDate = new Date("2022-06-16");
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("SectorActivity", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setPortifolioPer(response);
      });
  }, []);

  // PortfolioPerformanceDetails //
  useEffect(() => {
    FetchDataTypes("PortfolioPerformanceDetails", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setPortfolioDetails(response);
        setPortfolioCount(response);
      });
  }, []);

  const portfolioPageHandler = (pageNumbers: any, index: any) => {
    setPortfolioDetails(
      portfolioCount.slice(pageNumbers * 10 - 10, pageNumbers * 10)
    );
    setDetailsCurrentPage(pageNumbers);
  };

  // SectorPerformanceDetails //

  useEffect(() => {
    FetchDataTypes("SectorPerformanceDetails", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setSectorDetails(response);
        setSectorCount(response);
      });
  }, []);

  const SectorpageHandler = (pageNumbers: any, index: any) => {
    setSectorDetails(
      sectorCount.slice(pageNumbers * 10 - 10, pageNumbers * 10)
    );
    setSectorCurrentPage(pageNumbers);
  };

  // HistoricalPortfolioPerformance //

  useEffect(() => {
    FetchDataTypes("HistoricalPortfolioPerformance", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setHistoricalDetails(response);
        setHistoricalCount(response);
      });
  }, []);

  const HistoricalpageHandler = (pageNumbers: any, index: any) => {
    setHistoricalDetails(
      historicalCount.slice(pageNumbers * 10 - 10, pageNumbers * 10)
    );
    setHistoricalCurrentPage(pageNumbers);
  };

  // var filteredData =
  //   sectorAllocation &&
  //   sectorAllocation.filter((e: any) => {
  //     var date = new Date(e.perfDate);
  //     return date >= BeginDate && date <= EndDate;
  //   });

  var filteredDataPer =
    portifolioPer &&
    portifolioPer.filter((e: any) => {
      var date = new Date(e.perfDate);
      return date >= BeginDate && date <= EndDate;
    });

  const onExportHistoricalData = useCallback(() => {
    dataGridRefHistoricalData.current!.api.exportDataAsExcel();
  }, []);

  const exportPDFHistoricalData = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 10;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(12);

    const title = "Historical Performance Details";
    const headers = [
      [
        "clientName",
        "year",
        "jan",
        "feb",
        "mar",
        "april",
        "may",
        "june",
        "july",
        "aug",
        "sept",
        "oct",
        "nov",
        "ytd",
      ],
    ];

    const data = historicalDetails.map((e: any) => [
      e.clientName,
      e.year,
      e.jan,
      e.feb,
      e.mar,
      e.april,
      e.may,
      e.june,
      e.july,
      e.aug,
      e.sept,
      e.oct,
      e.nov,
      e.ytd,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 20);
    doc.autoTable(content);
    doc.save("HistoricalPerformance.pdf");
  };

  const onExportSectorData = useCallback(() => {
    dataGridRefSectorData.current!.api.exportDataAsExcel();
  }, []);

  const exportPDFSectorData = () => {
    const unit = "pt";
    const size = "A3"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 10;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(12);

    const title = "Sector Performance Details";
    const headers = [
      [
        "sectorName",
        "Date",
        "MTD",
        "QTD",
        "3M",
        "YTD",
        "1Y",
        "3Y",
        "5Y",
        "7Y",
        "10Y",
        "Since Inception",
      ],
    ];

    const data = sectorDetails.map((e: any) => [
      e.sectorName,
      e.perfDate,
      e.mtdGross,
      e.qtdGross,
      e.threeMonthsGross,
      e.oneYearGross,
      e.threeYearGross,
      e.fiveYearGross,
      e.sevenYearGross,
      e.tenYearGross,
      e.sinceInceptionGross,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 20);
    doc.autoTable(content);
    doc.save("SectorPerformanceDetails.pdf");
  };

  // Portfolio Export Details

  const onExportPortfolioData = useCallback(() => {
    dataGridRefPortfolioData.current!.api.exportDataAsExcel();
  }, []);

  const exportPDFPortfolioData = () => {
    const unit = "pt";
    const size = "A3"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 10;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(12);

    const title = "Portfolio Performance Details";
    const headers = [
      [
        "Date",
        "MTD",
        "QTD",
        "3M",
        "YTD",
        "1Y",
        "3Y",
        "5Y",
        "7Y",
        "10Y",
        "Since Inception",
      ],
    ];

    const data = PortfolioDetails.map((e: any) => [
      e.perfDate,
      e.mtdGross,
      e.qtdGross,
      e.threeMonthsGross,
      e.oneYearGross,
      e.threeYearGross,
      e.fiveYearGross,
      e.sevenYearGross,
      e.tenYearGross,
      e.sinceInceptionGross,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 20);
    doc.autoTable(content);
    doc.save("PortfolioPerformanceDetails.pdf");
  };

  return (
    <div>
      <div className="header">
        <h1 className="header-title">Performance</h1>
      </div>
      <div className="row">
        <div className="col-12 col-md-12 col-xxl-12 d-flex mt-4">
          <div className="card w-100">
            <div className="card-header">
              <h5 className="card-title">Sector Portfolio Performance</h5>
            </div>
            <div className="card-body">
              <div className="chart chart-xs">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-shrink">
                    <div className="ag-theme-alpine">
                      <SectorPerformanceChart />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-12 col-xxl-12 d-flex mt-4">
          <div className="card w-100">
            <div className="card-header">
              <h5 className="card-title">Historical Performance Details</h5>
              <div className="col-sm-12 my-3 text-end">
                <i
                  className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
                  style={{ fontSize: "16px" }}
                  onClick={onExportHistoricalData}
                ></i>
                <i
                  className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
                  onClick={() => exportPDFHistoricalData()}
                  style={{ fontSize: "16px" }}
                ></i>
              </div>
            </div>
            <div className="card-body">
              <div className="chart chart-xs">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-shrink">
                    <div
                      className="ag-theme-alpine"
                      style={{
                        height: "500px",
                        width: "100%",
                      }}
                    >
                      <AgGridReact
                        ref={dataGridRefHistoricalData}
                        rowData={historicalDetails}
                        columnDefs={HistoricalColumnDefs}
                        rowHeight={40}
                        pagination={true}
                        paginationPageSize={20}
                        //paginationAutoPageSize={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-12 col-xxl-12 d-flex mt-4">
          <div className="card w-100">
            <div className="card-header">
              <h5 className="card-title">Sector Performance Details</h5>
              <div className="col-sm-12 my-3 text-end">
                <i
                  className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
                  style={{ fontSize: "16px" }}
                  onClick={onExportSectorData}
                ></i>
                <i
                  className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
                  onClick={() => exportPDFSectorData()}
                  style={{ fontSize: "16px" }}
                ></i>
              </div>
            </div>
            <div className="card-body">
              <div className="chart chart-xs">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-shrink">
                    <div
                      className="ag-theme-alpine"
                      style={{
                        height: "500px",
                        width: "100%",
                      }}
                    >
                      <AgGridReact
                        ref={dataGridRefSectorData}
                        rowData={sectorDetails}
                        columnDefs={SectorColumnDefs}
                        rowHeight={40}
                        pagination={true}
                        paginationPageSize={20}
                        //paginationAutoPageSize={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-12 col-xxl-12 d-flex mt-4">
          <div className="card w-100">
            <div className="card-header">
              <h5 className="card-title">Portfolio Performance Details</h5>
              <div className="col-sm-12 my-3 text-end">
                <i
                  className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
                  style={{ fontSize: "16px" }}
                  onClick={onExportPortfolioData}
                ></i>
                <i
                  className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
                  onClick={() => exportPDFPortfolioData()}
                  style={{ fontSize: "16px" }}
                ></i>
              </div>
            </div>
            <div className="card-body">
              <div className="chart chart-xs">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-shrink">
                    <div
                      className="ag-theme-alpine"
                      style={{
                        height: "500px",
                        width: "100%",
                      }}
                    >
                      <AgGridReact
                        ref={dataGridRefPortfolioData}
                        rowData={PortfolioDetails}
                        columnDefs={PortfolioColumnDefs}
                        rowHeight={40}
                        pagination={true}
                        paginationPageSize={20}
                        //paginationAutoPageSize={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
